import AboutUsPage from "../Pages/AboutUs/AboutUsPage";
import HomePage from "../Pages/Home/HomePage";
import ProductsPage from "../Pages/Products/ProductsPage";
import FAQsPage from "../Pages/FAQs/FAQsPage";
import CareersPage from "../Pages/Careers/CareersPage";
import ContactUsPage from "../Pages/ContactUs/ContactUsPage";
import ThankYouPage from "../Pages/ThankYou/ThankYouPage";
import PrivacyPolicyPage from "../Pages/PrivacyPolicy/PrivacyPolicyPage";
import TermsandConditionsPage from "../Pages/TermsandConditions/TermsandConditionsPage";
import NotFound404 from "../Pages/404/404";
import TeamDetails from "../Pages/Book/TeamDetails";

export const routeList = [
  {
    path: "/",
    showMenuBar: false,
    menuTitle: "Home - Laguna Creek",
    menuLabel: "Home",
    meta_keyword: "PMS, POS, Tour Booking Platform",
    meta_description: "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.",
    Component: HomePage,
  },
  {
    path: "/products",
    showMenuBar: true,
    menuLabel: "Products",
    menuTitle: "Products - Laguna Creek",
    meta_keyword: "PMS, POS, Tour Booking Platform",
    meta_description: "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.",
    Component: ProductsPage,
  },
  {
    path: "/about-us",
    showMenuBar: true,
    menuLabel: "About Us",
    menuTitle: "About Us - Laguna Creek",
    meta_keyword: "PMS, POS, Tour Booking Platform",
    meta_description: "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.",
    Component: AboutUsPage,
  },
  {
    path: "/faq",
    showMenuBar: true,
    menuLabel: "FAQ",
    menuTitle: "FAQ - Laguna Creek",
    meta_keyword: "PMS, POS, Tour Booking Platform",
    meta_description: "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.",
    Component: FAQsPage,
  },
  {
    path: "/careers",
    showMenuBar: true,
    menuLabel: "Careers We are hiring!",
    menuTitle: "Careers - Laguna Creek",
    meta_keyword: "PMS, POS, Tour Booking Platform",
    meta_description: "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.",
    Component: CareersPage,
  },
  {
    path: "/contact-us",
    showMenuBar: true,
    menuLabel: "Contact Us",
    menuTitle: "Contact Us - Laguna Creek",
    meta_keyword: "PMS, POS, Tour Booking Platform",
    meta_description: "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.",
    Component: ContactUsPage,
  },
  {
    path: "/privacy-policy",
    showMenuBar: false,
    menuLabel: "Privacy Policy",
    menuTitle: "Privacy Policy - Laguna Creek",
    meta_keyword: "PMS, POS, Tour Booking Platform",
    meta_description: "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.",
    Component: PrivacyPolicyPage,
  },
  {
    path: "/terms-of-use",
    showMenuBar: false,
    menuLabel: "Terms of Use",
    menuTitle: "Terms of Use - Laguna Creek",
    meta_keyword: "PMS, POS, Tour Booking Platform",
    meta_description: "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.",
    Component: TermsandConditionsPage,
  },
  {
    path: "/thank-you",
    showMenuBar: false,
    menuLabel: "Thank You",
    menuTitle: "Thank You - Laguna Creek",
    meta_keyword: "PMS, POS, Tour Booking Platform",
    meta_description: "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.",
    Component: ThankYouPage,
  },
  {
    path: "/book/:team_name",
    showMenuBar: false,
    menuLabel: "Team",
    menuTitle: "Team - Laguna Creek",
    meta_keyword: "PMS, POS, Tour Booking Platform",
    meta_description: "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.",
    Component: TeamDetails,
  },
  {
    path: "/*",
    showMenuBar: false,
    menuLabel: "404",
    menuTitle: "NotFound - Laguna Creek",
    meta_keyword: "PMS, POS, Tour Booking Platform",
    meta_description: "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.",
    Component: NotFound404,
  },
];
